export const matchesPlateFilter = (
  plate: string,
  query: string,
  roomName?: string,
): boolean => {
  const normalizedQuery = query.trim().toLowerCase()
  if (normalizedQuery === "") {
    return true
  }
  if (plate.toLowerCase().includes(normalizedQuery)) {
    return true
  }
  return (roomName ?? "").toLowerCase().includes(normalizedQuery)
}
